require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-160-teamgantt-feedback-policy.json") })
        }
      }, "path---article-160-teamgantt-feedback-policy");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-160-teamgantt-feedback-policy!./.cache/json/article-160-teamgantt-feedback-policy.json
// module id = 508
// module chunks = 231608221292675